<template>
    <h4 class="bg-success p-3 rounded-2 text-white text-center fw-bold mb-5 mt-5">{{$t('Present Address')}}</h4>
    <div class="row mt-5">
        <div class="col-md-6">
            <b-form-group id="zip_code"
                          label-cols="3"
                          :label="$t('ZIP Code')"
                          label-for="zip_code"
                          class="requiredField">
                <b-form-input
                        type="text"
                        v-model="personalPresentAddress.zip_code"
                        class="form-control"
                        placeholder="Zip Code"
                        name="zip_code"
                        required
                        :state="getInputState(personalPresentAddress.zip_code)">
                </b-form-input>
<!--                        :value="convertNumberByLang(personalPresentAddress.zip_code, 'bn')"-->
                <b-form-invalid-feedback v-if="showError(personalPresentAddress.zip_code)">
                    Zip Code is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="village_house"
                    label-cols="3"
                    :label="$t('Village / House')"
                    label-for="village_house"
                    class="requiredField">
                <b-form-input
                        type="text" v-model="personalPresentAddress.village"
                        class="form-control"
                        placeholder="Village / House"
                        name="village_house"
                        :state="getInputState(personalPresentAddress.village)">
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(personalPresentAddress.village)">
                    Village is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="road_sector"
                    label-cols="3"
                    :label="$t('Road /Block /Sector')"
                    label-for="road_sector"
                    class="requiredField">
                <b-form-input
                        v-model="personalPresentAddress.road_no"
                        class="mb-3"
                        placeholder="Road /Block /Sector"
                        name="road"
                        :state="getInputState(personalPresentAddress.road_no)">
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(personalPresentAddress.road_no)">
                    Road No is required.
                </b-form-invalid-feedback>

            </b-form-group>
        </div>
        <div class="col-md-12">
            <b-form-group
                    id="permanent_address"
                    label-cols="4"
                    label-for="permanent_address">
                <b-form-checkbox
                        id="permanent_address"
                        v-model="status"
                        name="permanent_address"
                        value="accepted"
                        unchecked-value="not_accepted">
                    {{$t('Mark Same as Present Address')}}
                </b-form-checkbox>
            </b-form-group>
        </div>

        <div class="col-md-6">
            <b-form-group
                    id="zip_code"
                    label-cols="3"
                    :label="$t('ZIP Code')"
                    label-for="zip_code"
                    class="requiredField">
                <b-form-input
                        type="text"
                        v-model="personalPermanentAddress.zip_code"
                        class="form-control"
                        placeholder="Zip Code"
                        :readonly="status == 'accepted'"
                        :state="getInputState(personalPermanentAddress.zip_code)"
                        name="zip_code">
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(personalPermanentAddress.zip_code)">
                    Zip Code is required.
                </b-form-invalid-feedback>

            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="village_house"
                    label-cols="3"
                    :label="$t('Village / House')"
                    label-for="village_house"
                    class="requiredField">
                <b-form-input
                        type="text"
                        v-model="personalPermanentAddress.village"
                        class="form-control"
                        placeholder="Village / House"
                        name="village_house"
                        :readonly="status == 'accepted'"
                        :state="getInputState(personalPermanentAddress.village)">
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(personalPermanentAddress.village)">
                    Village is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="road_sector"
                    label-cols="3"
                    :label="$t('Road /Block /Sector')"
                    label-for="road_sector"
                    class="requiredField">
                <b-form-input
                        type="text"
                        v-model="personalPermanentAddress.road_no"
                        class="form-control"
                        placeholder="/Road /Block /Sector" name="road_sector"
                        :readonly="status == 'accepted'"
                        :state="getInputState(personalPermanentAddress.road_no)">
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(personalPermanentAddress.road_no)">
                    Road No is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-12 text-secondary text-center mb-5 mt-5">
            <h4 class="bg-success p-3 rounded-2 text-white text-center fw-bold">{{$t('Overseas Address')}}</h4>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="overses_country"
                    label-cols="3"
                    :label="$t('Country')"
                    label-for="country">
                <b-form-select
                        v-model="overseasData.overseasCountryCode"
                        :options="allCountry"
                        class="mb-3"
                        value-field="countryId"
                        text-field="country">
                    <option :value="null" selected>-- {{$t('Select One')}} --</option>
                </b-form-select>
            </b-form-group>
        </div>

        <div class="col-md-6">
            <b-form-group
                    id="village_house" label-cols="3"
                    :label="$t('Village / House')"
                    label-for="village_house">
                <b-form-input
                        type="text"
                        v-model="overseasData.overseasVillage"
                        class="form-control"
                        :placeholder="$t('Village / House')"
                        name="village_house">
                </b-form-input>
            </b-form-group>
        </div>
    </div>
</template>

<script>
    import apiRepository from '@/services/ApiRepository';
    import {toast} from "vue3-toastify";

    export default {
        name: "ProfileStepTwo",
        props: ["formData"],
        data() {
            return {
                personalPresentAddress: {...this.formData.userProfile.presentAddress},
                personalPermanentAddress: {...this.formData.userProfile.permanentAddress},
                overseasData: {
                    ...this.formData.userProfile.overseasCountryCode,
                    ...this.formData.userProfile.overseasVillage,
                },
                status: 'not_accepted',
                allCountry: [],
            };
        },
        mounted() {
            this.countryData();
            this.fetchProfileData();

        },
        computed: {

        },
        watch: {
            personalPresentAddress: {
                handler(newVal) {
                    this.$emit("update:formData", {
                        ...this.formData,
                        userProfile: {
                            ...this.formData.userProfile,
                            presentAddress: this.convertToCommaSeparatedString(newVal)
                        }
                    });
                },
                deep: true
            },
            personalPermanentAddress: {
                handler(newVal) {
                    this.$emit("update:formData", {
                        ...this.formData,
                        userProfile: {
                            ...this.formData.userProfile,
                            permanentAddress: this.convertToCommaSeparatedString(newVal)
                        }
                    });
                },
                deep: true
            },
            overseasData: {
                handler(newVal) {
                    this.$emit("update:formData", {
                        ...this.formData,
                        userProfile: {
                            ...this.formData.userProfile,
                            overseasCountryCode: newVal.overseasCountryCode,
                            overseasVillage: newVal.overseasVillage,
                        },
                    });
                },
                deep: true,
            },

            status(newStatus) {
                if (newStatus === 'accepted') {
                    this.personalPermanentAddress.zip_code = this.personalPresentAddress.zip_code;
                    this.personalPermanentAddress.village = this.personalPresentAddress.village;
                    this.personalPermanentAddress.road_no = this.personalPresentAddress.road_no;
                } else {
                    this.personalPermanentAddress.zip_code = '';
                    this.personalPermanentAddress.village = '';
                    this.personalPermanentAddress.road_no = '';
                }
            },

        },
        methods: {
            convertToCommaSeparatedString(addressObj) {
                return [
                    String(addressObj.zip_code || ''),
                    String(addressObj.village || ''),
                    String(addressObj.road_no || '')
                ].join(',');
            },
            /*updateParent() {
              this.$emit("update:formData", this.localFormData); // Emit updated data to parent
            },*/
            countryData() {
                apiRepository.getCountry().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.allCountry = response.data;
                    }
                })
            },
            fetchProfileData() {
                try {
                    apiRepository.userDataGet().then((response) => {
                        if (response && response.data && response.data.userProfile) {
                            const presentParts = response.data.userProfile.presentAddress?.split(',') || [];
                            const permanentParts = response.data.userProfile.permanentAddress?.split(',') || [];

                            this.personalPresentAddress = {
                                zip_code: presentParts[0] || '',
                                village: presentParts[1] || '',
                                road_no: presentParts[2] || ''
                            };

                            this.personalPermanentAddress = {
                                zip_code: permanentParts[0] || '',
                                village: permanentParts[1] || '',
                                road_no: permanentParts[2] || ''
                            };
                            this.overseasData.overseasCountryCode = response.data.userProfile.overseasCountryCode;
                            this.overseasData.overseasVillage = response.data.userProfile.overseasVillage;
                        } else {
                            console.error('Data not Found!!');
                        }
                    });
                } catch (e) {
                    toast.error('Invalid Request!', e);
                }

            },
            getInputState(value) {
                if (value === '') return false;
                if (typeof value === 'string') return value.trim().length > 0;
                return !!value;
            },
            showError(value) {
                return value === '' || (typeof value === 'string' && value.trim() === '');
            },
            /*convertNumberByLang(value, lang = 'en') {
                if (value == null) return '';

                const enToBnDigits = ['০','১','২','৩','৪','৫','৬','৭','৮','৯'];
                const bnToEnDigits = ['0','1','2','3','4','5','6','7','8','9'];

                const str = value.toString();

                if (lang === 'bn') {
                    return str.replace(/[0-9]/g, d => enToBnDigits[d]);
                } else {
                    return str.replace(/[০-৯]/g, d => bnToEnDigits[enToBnDigits.indexOf(d)]);
                }
            },

            handleZipInput(event) {
                const rawValue = event.target.value;
                const englishValue = this.convertNumberByLang(rawValue, 'en');
                this.personalPresentAddress.zip_code = englishValue;
            }*/
        },
    };
</script>

<style scoped>
    input[readonly] {
        background-color: #eaeaea; /* Light gray background */
        cursor: not-allowed; /* Show "not-allowed" cursor */
    }
</style>
